<template>
  <svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.99758 0C4.47783 0 0 4.48816 0 10.0206C0 17.0589 9.99758 24 9.99758 24C9.99758 24 19.9952 17.1998 19.9952 10.0206C20 4.48816 15.5222 0 9.99758 0ZM9.99758 14.5914C7.38551 14.5914 5.2726 12.4687 5.2726 9.8555C5.2726 7.24226 7.39036 5.11961 9.99758 5.11961C12.6048 5.11961 14.7226 7.24226 14.7226 9.8555C14.7226 12.4687 12.6048 14.5914 9.99758 14.5914Z" fill="currentColor"/>
  </svg>
</template>
